import { render, staticRenderFns } from "./smartPerspective.vue?vue&type=template&id=1fc60f7c&scoped=true"
import script from "./smartPerspective.vue?vue&type=script&lang=js"
export * from "./smartPerspective.vue?vue&type=script&lang=js"
import style0 from "./smartPerspective.vue?vue&type=style&index=0&id=1fc60f7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc60f7c",
  null
  
)

export default component.exports